export default "__VITE_ASSET__3afcbcdc__"